

import Badge from "@/app/components/Badge";
import { formatDate } from "@/lib/data";

interface QuotationBasicInfoProps {
  clientName?: string;
  eventType?: string;
  eventName?: string;
  guests?: number | string;
  guestCount?: number | string;
  eventDate?: string;
  venue?: string;
  venueName?: string;
  validUntil?: string;
  status?: string;
}

export default function QuotationBasicInfo({
  clientName,
  eventType,
  eventName,
  guests,
  guestCount,
  eventDate,
  venue,
  venueName,
  validUntil,
  status,
}: QuotationBasicInfoProps) {
  return (
    <div className="bg-white rounded-xl border border-stone-200 shadow-sm overflow-hidden">
      <div className="px-6 py-4 bg-gradient-to-r from-stone-50 to-white border-b border-stone-200">
        <h2 className="text-lg font-semibold text-stone-800">Basic Information</h2>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">Client Name</label>
            <div className="px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-stone-800">
              {clientName || "-"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">Event Type</label>
            <div className="px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-stone-800">
              {eventType || "-"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">Event Name</label>
            <div className="px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-stone-800">
              {eventName || "-"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">Guests</label>
            <div className="px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-stone-800">
              {guests || guestCount || "-"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">Event Date</label>
            <div className="px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-stone-800">
              {formatDate(eventDate || "")}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">Venue</label>
            <div className="px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-stone-800">
              {venue || venueName || "-"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">Valid Until</label>
            <div className="px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-stone-800">
              {formatDate(validUntil || "")}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">Status</label>
            <div className="px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg">
              <Badge label={status || "draft"} status={status || "draft"} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
